const Contact = () => (
<main>
    <h1>Contact Us</h1>
    <p>Questions or catering requests? Email us at <strong>WRITE ERROR</strong> or call ERROR</p>
  </main>
);

export default Contact;